<ng-template #headerTpl>
  <div class="flex flex-col w-full gap-1.5" *transloco="let t">
    <div class="flex justify-between items-start w-full">
      <div class="flex flex-col gap-1.5">
        <span class="text-sm font-semibold text-ink-strong">
          {{ t('ORDER-DETAILS.SIGNING_STATUS') }}
        </span>

        @if (orderStatusDetails().length) {
        <span class="text-xs text-ink-muted">
          {{ orderStatusDetails().length | translocoDecimal }}
          {{ t('CONTRACT_ORDER.RECIPIENTS_LABEL') }}
        </span>
        }
      </div>

      <button type="button" class="p-1 rounded-lg bg-surface-subtle shrink-0 cursor-pointer" (click)="closeModal()">
        <div class="flex items-center justify-center size-6 rounded-full text-ink-muted">
          <mat-icon class="size-2.5!" svgIcon="close" />
        </div>
      </button>
    </div>
  </div>
</ng-template>

<dss-libs-ui-base-modal [header]="headerTpl" [showClose]="false" headerPadding="py-3.5 px-5" (closed)="closeModal()">
  @if (orderStatusDetailsResource.isLoading()) {
  <dss-libs-ui-modal-list-skeleton />
  } @else {
  <div class="flex flex-col divide-y divide-stroke max-h-84 overflow-y-auto" *transloco="let t">
    @for (recipient of orderStatusDetails(); track $index) {
    <div class="flex items-center gap-2.5 px-4 py-3">
      <div
        class="size-8 rounded-2xl bg-primary-soft flex items-center justify-center text-sm font-semibold text-primary shrink-0"
      >
        {{ recipient.name | initials }}
      </div>
      <div class="flex flex-col gap-1 min-w-0 flex-1">
        <span class="text-sm font-semibold text-ink-strong truncate">{{ recipient.name }}</span>
        <span class="text-shadow-xs text-xs text-ink-tertiary truncate">{{
          t(recipientActionTranslationKey.get(recipient.action)!)
        }}</span>
      </div>
      <div class="flex flex-col items-end gap-1 shrink-0">
        <div
          class="px-2 py-0.5 rounded-xl text-xs font-medium"
          [class]="recipientActionStatusMapper.get(recipient.actionStatus)!.badgeClass"
        >
          {{ t(recipientActionStatusMapper.get(recipient.actionStatus)!.translationKey) }}
        </div>
        @if (recipient.actionDate) {
        <span class="text-[0.625rem] text-ink-muted">{{
          recipient.actionDate | translocoDate : { dateStyle: 'medium' }
        }}</span>
        }
      </div>
    </div>
    }
  </div>
  }
</dss-libs-ui-base-modal>
